

const menus = [
    {
        id: 1,
        name: 'Home',
        links: '/',
    },
    {
        id: 4,
        name: 'Collection',
        links: '/nft-item',
    },
]

export default menus;
